import { render, staticRenderFns } from "./OrderSetView.vue?vue&type=template&id=473df321&scoped=true&"
import script from "./OrderSetView.vue?vue&type=script&lang=js&"
export * from "./OrderSetView.vue?vue&type=script&lang=js&"
import style0 from "./OrderSetView.vue?vue&type=style&index=0&id=473df321&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473df321",
  null
  
)

export default component.exports